
const SET_EDITOR_VALUE = '@@app/SET_EDITOR_VALUE';
const SET_IS_USE_FORCE_LAYOUT = '@@app/SET_IS_USE_FORCE_LAYOUT';

const SET_LAYOUT_TYPE = '@@app/SET_LAYOUT_TYPE';

export default {
  SET_EDITOR_VALUE,
  SET_IS_USE_FORCE_LAYOUT,
  SET_LAYOUT_TYPE
};
